document.addEventListener('DOMContentLoaded', function(){

  
  let selectedValue = document.querySelector('input.checkbox-custom:checked').id;
  document.querySelector('#swatches').value =  selectedValue;

  document.querySelectorAll('.custom-pro-swatch li label').forEach((swatch)=>{
  
    swatch.addEventListener('click', function(e){
    
      
      document.querySelector('#swatches').value = this.innerText;
     
      
    });
    
  });
  


  document.querySelectorAll('.product-form input').forEach((input)=>{


    input.addEventListener('input', function(e){

      if(this.closest('.product-form').querySelector('form').querySelector(`input[name="${this.name}"]`))
      {
        
        if(!this.closest('.product-form').querySelector('form').querySelector(`input[name="${this.name}"]`).name.includes('black ink for')){


          this.closest('.product-form').querySelector('form').querySelector(`input[name="${this.name}"]`).value = this.value;
        }


      }


    });

  })
  
  
  
});